import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithPwPrefix } from 'store/middleware/pwContextMiddleware';
import type {
  PayHubCashierContractsCashierBrowserDataRequest,
  PayHubWidgetContractsSubmitPaymentResponse,
} from 'store/models';

import { WIDGET_API } from '../../utils';

interface PostConsentRequest {
  id: number;
  body: {
    browser_data: PayHubCashierContractsCashierBrowserDataRequest;
    fingerprint: string;
  };
}

export const cascadingAPI = createApi({
  reducerPath: 'cascadingAPI',
  baseQuery: createBaseQueryWithPwPrefix(WIDGET_API),
  endpoints: (builder) => ({
    postPaymentGroupConsent: builder.query<PayHubWidgetContractsSubmitPaymentResponse, PostConsentRequest>({
      query: ({ id, body }) => ({
        url: `/payments/groups/${id}/consent`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useLazyPostPaymentGroupConsentQuery } = cascadingAPI;
export default cascadingAPI.reducer;
